import { gameAssetUrl } from "../config/assets";
import { ASSETS_BASE_URL } from "./assets";
const AMOUNT_REWARDS = [
    "coins",
    "xp",
    "champions_qualification_points",
];
// The scraper names these in English, so the name is rebuilt from the type.
const LITERAL_REWARDS = [
    "evo",
    "graduated_access_transfer_market_entry",
];
export const objectiveReward = (reward, t) => {
    if (!reward)
        return reward;
    const { type, amount, imgKey, imgId } = reward;
    const rewardImgURL = reward.rewardImgURL ??
        (imgKey
            ? `${ASSETS_BASE_URL}/${imgKey}`
            : type === "coins"
                ? `${ASSETS_BASE_URL}/misc/fut-coin-large.png`
                : type === "xp"
                    ? `${ASSETS_BASE_URL}/misc/sp-tmp.png`
                    : type === "champions_qualification_points"
                        ? `${ASSETS_BASE_URL}/misc/champions-points.png`
                        : undefined);
    const packImageURL = reward.packImageURL ??
        (type === "pack" && imgId != null
            ? gameAssetUrl(`packs/${imgId}.png`)
            : undefined);
    const literal = LITERAL_REWARDS.find((literalType) => literalType === type);
    const name = literal
        ? // Keeps the scraper's "2x " count prefix.
            (reward.name?.match(/^\d+x /)?.[0] ?? "") +
                t(`reward.${literal}`, { amount: (amount ?? 0).toLocaleString("en-US") })
        : (reward.name ??
            (AMOUNT_REWARDS.some((amountType) => amountType === type) &&
                amount != null
                ? t(`reward.${type}`, {
                    amount: amount.toLocaleString("en-US"),
                })
                : undefined));
    return { ...reward, rewardImgURL, packImageURL, name };
};
//# sourceMappingURL=objectiveReward.js.map